import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerV2InitialState, basedDataReducerV2 } from 'redux/base-reducer-v2';

import { ICompanyType } from 'modules/company-type';

import { ICompaniesModal, ICompany, ISingleCompany } from '../types/companies.types';

export interface CompaniesState extends BaseDataReducerV2InitialState<ICompany> {
  perPage: number;
  selectedCompany: ICompany | null;
  editableCompany: ISingleCompany | null;
  currentModal: ICompaniesModal | null;
  availableTypes: ICompanyType[];
}

const { initialState, AC, reducer, thunks } = basedDataReducerV2<ICompany, CompaniesState>('app-companies');

const companiesState: CompaniesState = {
  ...initialState,
  perPage: 10,
  currentModal: null,
  selectedCompany: null,
  editableCompany: null,
  availableTypes: [],
};

export const companies = createSlice({
  name: 'companies',
  initialState: companiesState,
  reducers: {
    setAvailableTypes(state, action: PayloadAction<ICompanyType[]>) {
      state.availableTypes = action.payload;
    },
    setSelectedCompany(state, action: PayloadAction<ICompany | null>) {
      state.selectedCompany = action.payload;
    },
    setCompaniesModal(state, action: PayloadAction<ICompaniesModal | null>) {
      state.currentModal = action.payload;
    },
    setEditableCompany(state, action: PayloadAction<ISingleCompany | null>) {
      state.editableCompany = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as CompaniesState, action);
    });
  },
});
export const CompaniesAC = AC;
export const onCompaniesSort = thunks.onSort;
export const onCompaniesFilter = thunks.onFilter;
export const clearCompaniesFilters = AC.clearFilters;
export const setCompaniesCurrentPage = AC.setCurrentPage;

export const { setSelectedCompany, setCompaniesModal, setEditableCompany, setAvailableTypes } = companies.actions;
